import * as React from "react";
import type { SVGProps } from "react";
const SvgFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M13.2 2.4v4.8a1.2 1.2 0 0 0 1.2 1.2h4.8m-5.794-6H7.2a2.4 2.4 0 0 0-2.4 2.4v14.4a2.4 2.4 0 0 0 2.4 2.4h9.6a2.4 2.4 0 0 0 2.4-2.4V8.194a2.4 2.4 0 0 0-.703-1.697l-3.394-3.394a2.4 2.4 0 0 0-1.697-.703Z"
    />
  </svg>
);
export default SvgFile;
